// TODO check if more values can be passed to product and cart pages

// https://business.twitter.com/en/help/campaign-measurement-and-analytics/conversion-tracking-for-websites.html

/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Load Twitter Ads event listeners
 * */

// Pixel load event listener
pmw.bus.on("pmw:load-pixels", () => {

	if (pmwDataLayer?.pixels?.twitter?.pixel_id && !pmwDataLayer?.pixels?.twitter?.loaded) {
		if (pmw.consent.canPixelBeFired("marketing", "Twitter")) pmw.loadTwitterPixel()
	}
})

// add-to-cart event
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: add_to_cart event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: add_to_cart event sent")
		}
	} catch (e) {
		console.error(e)
	}
})

// view product event
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: view_content event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: view_content event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// // view category event
// jQuery(document).on('pmw:pixel:view-category', function () {
//
// 	if(pmw.canNotFireTwitterEvent return;
//
// 	// twq('track', 'AddToWishlist');
// });

// add-to-wishlist event
pmw.bus.on("pmw:pixel:add-to-wishlist", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: add_to_wishlist event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: add_to_wishlist event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// start checkout event
pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: initiate_checkout event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: initiate_checkout event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// add-payment-info event
pmw.bus.on("pmw:pixel:add-payment-info", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: add_payment_info event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: add_payment_info event sent")
		}

	} catch (e) {
		console.error(e)
	}
})

// View search event
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: search event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name)
			pmw.console.log("Twitter Pixel: search event sent")
		}

	} catch (e) {
		console.error(e)
	}
})


// view order received page event
// TODO find out under which circumstances to use different values in content_type
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "twitter")) return
		if(pmw.canNotFireTwitterEvent()) return

		const twitterData = payload.pixels?.twitter;
		if (!twitterData) return;

		if (twitterData.event_type === 'event') {
			twq("event", twitterData.event_id, twitterData.event_data)
			pmw.console.log("Twitter Pixel: purchase event sent", twitterData.event_data)
		} else {
			// Legacy event
			twq("track", twitterData.event_name, twitterData.event_data)
			pmw.console.log("Twitter Pixel: purchase event sent", twitterData.event_data)
		}

	} catch (e) {
		console.error(e)
	}
})

